import { render, staticRenderFns } from "./TicAlipayPdf.vue?vue&type=template&id=3f05d175&scoped=true&"
import script from "./TicAlipayPdf.vue?vue&type=script&lang=js&"
export * from "./TicAlipayPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f05d175",
  null
  
)

export default component.exports